import React from 'react';
export const CFIconArrowDiagonalRightDown = {
    alias: 'arrow-diagonal-right-down',
    defaultTitle: 'Arrow Diagonal Right Down',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M17 8a1 1 0 0 0-1 1v5.586L7.707 6.293a.999.999 0 1 0-1.414 1.414L14.586 16H9a1 1 0 1 0 0 2h8a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1Z' }))),
};
